import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SubmitErrorType } from '@typesApp/SubmitError'
import { scrollToDrawerTop } from '@utils/scrollToDrawerTop'
import { closeApp, } from '@redux/slices/workflowSlice'
import { resetSubmitError, submitErrorSelector } from '@redux/slices/claimSubmitSlice'
import { ClaimErrorModal } from './components/ClaimErrorModal'
import { QuoteErrorModal } from './components/QuoteErrorModal'

const CLAIM_RETRYABLE_ERRORS = [
  // presently these retryable errors are not presented as modals
  // and are handled within the review claim view
  // INSURER_ERROR
  // LIMIT_REACHED
  // CLAIM_ACKNOWLEDGED_NULLIFIED
] as SubmitErrorType[]

const CLAIM_NON_RETRYABLE_ERRORS = [
  SubmitErrorType.LIMIT_REACHED,
  SubmitErrorType.TIMEOUT_RETRY,
  SubmitErrorType.CLAIM_ACKNOWLEDGED,
  SubmitErrorType.SUBMIT_CLAIM_NO_RETRY_ERROR,
]

const QUOTE_RETRYABLE_ERRORS = [
  SubmitErrorType.REQUEST_QUOTE_ERROR,
  SubmitErrorType.SUBMIT_QUOTE_ERROR,
]

const QUOTE_NON_RETRYABLE_ERRORS = [
  SubmitErrorType.REQUEST_QUOTE_RESTRICTED,
  SubmitErrorType.INSUFFICIENT_COVERAGE,
  SubmitErrorType.SUBMIT_QUOTE_NO_RETRY_ERROR,
]

const CLAIM_ERRORS = CLAIM_RETRYABLE_ERRORS.concat(CLAIM_NON_RETRYABLE_ERRORS)
const QUOTE_ERRORS = QUOTE_RETRYABLE_ERRORS.concat(QUOTE_NON_RETRYABLE_ERRORS)

interface SubmitErrorListenerProps {
  nonRetryableErrorsOnly?: boolean
}

export const SubmitErrorListener: React.FC<SubmitErrorListenerProps> = (props) => {
  const { nonRetryableErrorsOnly = false } = props
  const dispatch = useDispatch()
  const error = useSelector(submitErrorSelector)

  /*
  Scroll to top on submit error
  */
  useEffect(() => {
    if (error.type !== SubmitErrorType.NONE) {
      scrollToDrawerTop()
    }
  }, [error])

  const onProceedToCheckout = () => {
    dispatch(resetSubmitError())
    dispatch(closeApp())
  }

  const onBackToForm = () => {
    dispatch(resetSubmitError())
  }

  const isClaimError =  nonRetryableErrorsOnly
    ? CLAIM_NON_RETRYABLE_ERRORS.includes(error.type)
    : CLAIM_ERRORS.includes(error.type)

  const isQuoteError = nonRetryableErrorsOnly
    ? QUOTE_NON_RETRYABLE_ERRORS.includes(error.type)
    : QUOTE_ERRORS.includes(error.type)

  return (
    <>
      {isClaimError &&
        <ClaimErrorModal error={error} onClose={onProceedToCheckout} />
      }

      {isQuoteError &&
        <QuoteErrorModal error={error} onBackToForm={onBackToForm} onProceedToCheckout={onProceedToCheckout} />
      }
    </>
  )
}
